import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyCva56M7auXXT2idvp3ha6r_yGLuEW57H0',
  authDomain: 'qick-dashboard-v4.firebaseapp.com',
  projectId: 'qick-dashboard-v4',
  storageBucket: 'qick-dashboard-v4.firebasestorage.app',
  messagingSenderId: '316597061323',
  appId: '1:316597061323:web:9b7fa3ae01a0a73e77bd4e',
  measurementId: 'G-7YC44C7YL6',
};

const app = initializeApp(firebaseConfig);

// Check if messaging is supported before initializing
let messaging = null;
let messagingSupported = false;

// Initialize messaging only if supported
const initializeMessaging = async () => {
  try {
    messagingSupported = await isSupported();
    if (messagingSupported) {
      messaging = getMessaging(app);
      return messaging;
    }
    return null;
  } catch (error) {
    console.log('Firebase messaging not supported:', error);
    return null;
  }
};

// Request permission to receive notifications
const VAPID_KEY =
  'BHCLiYKz86b76SkPAPNhNEMLO1dGEQGHcpQTwroi64IWpn_OOr1q7Y_raYiGQZQ2WTmPHKMYOBFNH8gaQkvnb0U';
export const requestNotificationPermission = async () => {
  try {
    // Check if messaging is supported first
    if (!messaging) {
      messaging = await initializeMessaging();
    }

    if (!messaging || !messagingSupported) {
      console.log('Firebase messaging not supported in this browser');
      return null;
    }

    console.log('Requesting notification permission...');
    const permission = await Notification.requestPermission();

    if (permission === 'granted') {
      console.log('Notification permission granted.');
      const token = await getToken(messaging, { vapidKey: VAPID_KEY });

      if (token) {
        console.log('FCM token received:', token);
        return token;
      } else {
        console.log('No registration token available. Request permission again.');
        return null;
      }
    } else {
      console.log('Notification permission not granted.');
      return null;
    }
  } catch (error) {
    console.log('An error occurred while requesting notification permission:', error);
    return null;
  }
};

// Listen for foreground messages
export const onMessageListener = () =>
  new Promise((resolve) => {
    if (!messaging || !messagingSupported) {
      console.log('Firebase messaging not supported, skipping message listener');
      resolve(null);
      return;
    }

    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
